import {Promise} from '@acng/frontend-bounty';
import {ARRAY, BOOLEAN, OBJECT, STRING, typeguard} from '@acng/frontend-bounty/typeguard';
import {createGlobalContext} from '@acng/frontend-relativity';
import {CTX_PROVIDE} from '@acng/frontend-relativity/minify';

import {inject} from 'acng/core/service/ng.js';

type Amateur = import('acng/amateurPool/factory/Amateur').Amateur;
type PinData = {id: string; isPin: boolean};

export const ctxPins = createGlobalContext(false);

/**
 * @deprecated Use byAmateur instead
 */
const pins: string[] & {changed?: number} = [];
pins.changed = 0;

const byAmateur = new Set<string>();
/**
 * @deprecated Implement something different
 */
let resolvePins: ((res: typeof pins) => void) | undefined;

/**
 * @deprecated
 * Required for the onsd-thing
 */
export const promise = new Promise((resolve: (value: typeof pins) => void) => {
  resolvePins = () => resolve(pins);
});

// TODO consider loading the pins here and rename into init or so
export const runSock = [
  'sock',
  (sock: core.Sock) => {
    sock.registerHandler('pin.changed', (data: PinData) => {
      ASSERT: typeguard('pin', data, OBJECT({id: STRING, isPin: BOOLEAN}));

      const id = data.id;
      if (data.isPin) {
        if (pins.indexOf(id) < 0) {
          pins.unshift(id);
          pins.changed!++;
          byAmateur.add(id);
        }
      } else {
        const idx = pins.indexOf(id);
        if (idx >= 0) {
          pins.splice(idx, 1);
          pins.changed!++;
        }
        byAmateur.delete(id);
      }
      ctxPins[CTX_PROVIDE](null, true);
    });
    sock.addEventListener('open', load);
  },
];
export const checkPin = (amateur: Amateur) => byAmateur.has(amateur.id);

export const checkPinById = (amateurId: string) => byAmateur.has(amateurId);

export const removePin = async (amateur: Amateur) => {
  const http = inject('http');
  const sock = inject('sock');
  await http().delete(`/api/pin/amateur/${amateur.id}`, {dontIntercept: true});
  sock.publish('pin.changed', {id: amateur.id, isPin: false} as PinData);
};

export const addPin = async (amateur: Amateur) => {
  const http = inject('http');
  const sock = inject('sock');
  await http().put(`/api/pin/amateur/${amateur.id}`, {}, {dontIntercept: true});
  sock.publish('pin.changed', {id: amateur.id, isPin: true} as PinData);
};

const load = async () => {
  const http = inject('http');
  const res: angular.IHttpResponse<string[]> = await http().get('/api/pin/all', {dontIntercept: true});

  ASSERT: typeguard('pins', res.data, ARRAY(STRING));

  pins.length = 0;
  byAmateur.clear();
  for (let i = 0; i < res.data.length; i++) {
    const id = res.data[i];
    byAmateur.add(id);
    pins.push(id);
  }
  resolvePins!(pins);
  ctxPins.provide(null, true);
};
